import { render, staticRenderFns } from "./detail-tab-avaliacao.vue?vue&type=template&id=4ceed388&scoped=true&"
import script from "./detail-tab-avaliacao.vue?vue&type=script&lang=js&"
export * from "./detail-tab-avaliacao.vue?vue&type=script&lang=js&"
import style0 from "./detail-tab-avaliacao.vue?vue&type=style&index=0&id=4ceed388&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceed388",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VChip,VFadeTransition})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ceed388')) {
      api.createRecord('4ceed388', component.options)
    } else {
      api.reload('4ceed388', component.options)
    }
    module.hot.accept("./detail-tab-avaliacao.vue?vue&type=template&id=4ceed388&scoped=true&", function () {
      api.rerender('4ceed388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/detail-tab-avaliacao/detail-tab-avaliacao.vue"
export default component.exports